import UserLayout from "../components/UserLayout";
import Login from "../components/Login";
const LoginPage = () => {
    return (
        <UserLayout>
            <Login />
        </UserLayout>
    );
}

export default LoginPage;